/* @flow */

import React from 'react';
import useSheet from 'app/jss';

type Props = {
  children: mixed,
  classes: Object,
  href: string,
};

const defaultProps = {};

function MarkdownLink({
  children,
  classes,
  href,
}: Props) {
  return (
    <a
      className={classes.link}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
    </a>
  );
}

MarkdownLink.defaultProps = defaultProps;

function applyStyles(theme) {
  return {
    link: {
      color: theme.color.basis5,
    },
  };
}

export default useSheet(applyStyles)(MarkdownLink);
